import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import CustomPagination from "../../../../../components/CustomPagination";
import styles from "./style"

const BankTransactionsList = ({data}) => {
  return(
    <>

           
      <TableContainer  sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>Date</TableCell>
              <TableCell sx={styles.tableHead}>Statement Details</TableCell>
              <TableCell sx={styles.tableHead}>Deposits</TableCell>
              <TableCell sx={styles.tableHead}>Withdrawls</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {!data ? ( 
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              data?.map((item, index) => (
                <TableRow key={index} sx={{verticalAlign:"baseline"}}>
                  <TableCell sx={styles.tabledata}>{item?.type} </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.total}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.amount}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.var}</TableCell>

                </TableRow>
              ))
            )}
          </TableBody>

        </Table>
        {data &&
       <CustomPagination
         //  pageCount={totalCount}         
         //  page={page}
         //  setPage={setPage}
         //  rowsPerPage={rowsPerPage}
         //  setRowsPerPage={setRowsPerPage}
         //  totalItems={ProfitData.length}
       />} 

      </TableContainer>


    </>
  )
}

export default BankTransactionsList